import React from 'react';
import { observer } from 'mobx-react';
import { config } from '../../config';

// Helpers
import { closeDrawer, handleSwitchInputKeys } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
// import DOMPurify from 'dompurify';

// Components
import * as icons from '../Icons/Icons';
import BlackoutList from '../BlackoutDates/BlackoutList';
import Payments from '../Payments/Payments';
import Pricing from './Pricing';
import ScheduleDate from '../Modules/ScheduleDate';
import ScheduleTable from '../Modules/ScheduleTable';
// import ssLogo from '../../../img/logo-alt.png';

const ScheduleHybrid = observer(class ScheduleHybrid extends React.Component {
  constructor() {
    super();

    // Set initial state
    this.state = {
      step: 1,
      appointmentStartDate: null,
      appointmentEndDate: null,
      examSid: null,
      sessionSid: null,
      complete: false,
      isSubmitDisabled: true
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { PaymentStore } = this.props.store;
    const { fees } = prevState;

    const newFees = this.state.fees;

    if (fees && fees.schedulingRuleInformation && newFees && newFees.schedulingRuleInformation) {
      // No-op
    } else if (fees && fees.schedulingRuleInformation && !newFees) {
      // If the fees object goes away, remove the rule info
      PaymentStore.schedulingRuleInformation = [];
    } else if (newFees && newFees.schedulingRuleInformation) {
      // Else, update it
      PaymentStore.schedulingRuleInformation = newFees.schedulingRuleInformation;
    }
  }

  componentWillMount() {
    const { ScheduleStore } = this.props.store;
    ScheduleStore.onlineDate = null;

    // Set the examSid and sessionSid
    if(!this.props.reschedule && !this.props.skipUrl) {
      this.setState({
        examSid: this.getSid(2),
        sessionSid: this.getSid(4)
      })
    } else {
      this.setState({
        examSid: this.props.examSid,
        sessionSid: this.props.sessionSid
      })
    }
  }

  componentDidMount() {
    const { ScheduleStore } = this.props.store;

    // Get Session Proctor info that is needed for getting and displaying cost on splash page
    /*
    if (!this.state.proctorLocationSid) {
      ProctorStore.getSessionProctorGroups(this.state.examSid, this.state.sessionSid, null, this.initialFee)
    }

     */
    // Reset any old schedule data
    ScheduleStore.resetData();

    // TODO: may remove this as we are not supporting register blast in the first go
    // Setup window listener to find when scheduling is complete
    window.addEventListener('message', event => {
      if (event.origin === config.domain && event.data === "SpRbScheduled__Confirmed") {
        this.setState({
          complete: true
        });
      }
    });
  }

  setLocation = (i, data) => {
    const { ScheduleStore } = this.props.store;

    ScheduleStore.onlineLocation = data[0].location.sid;
  }

  // Next two functions set fees to state for displaying before scheduling an exam
  /*
  initialFee = (data) => {
    const { ProctorStore } = this.props.store;
    let proctorLocationList = data.filter(location => location.workflowModule === 'hybrid-scheduling')
    let proctorLocation = proctorLocationList[0].proctorLocationSids;

    proctorLocationList.forEach(location => {
      if (location.sid === this.props.proctorGroupSid) {
        proctorLocation = location.proctorLocationSids;
      }
    })

    this.setState({
      initialProctorLocationSid: proctorLocation
    })
    // Api was not liking how proctorLocationSids were given so we have to encode and then stringify it for it work properly
    const arrayString = encodeURIComponent(JSON.stringify(proctorLocation))

    const query = `?proctorLocationSids=${arrayString}&examSessionSid=${this.state.sessionSid}`;
    const backgroundLoad = true;

    ProctorStore.searchProctors(query, this.setInitialFee, null, backgroundLoad);
  }

  setInitialFee = (i, data) => {
    if(data[0] && data[0].fees && !data[0].fees.userTotal) {
      // Sometimes the API won’t include a
      // value for userTotal, but if you
      // send a request without a total, it
      // will throw a fit. So we need to set it
      // to 0 if it isn’t present.
      data[0].fees.userTotal = 0;
    }

    this.setState({
      initialFees: data[0].fees.userTotal
    });
  }
   */

  getSid = (segment) => {
    // Get the exam sid from the URL
    let pathname = '';

    if(typeof this.props !== 'undefined') {
      pathname = this.props.routing.location.pathname;
    } else {
      pathname = this.routing.location.pathname;
    }

    let pathArray = pathname.split('/');

    if (pathArray[0] === '') {
      pathArray.splice(0, 1);
    }

    const sid = pathArray[segment];
    return sid;
  }

  setStep = (e, step) => {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step
    }, function(){
      // Hide the close button on the last step so the
      // student has to click the return to dashboard button
      if(this.state.step === 4) {
        this.props.store.SessionStore.hideDrawerClose = true;
      }
    });
  }

  nextStep = (e) => {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step: this.state.step + 1
    });
  }

  prevStep() {
    this.setState({
      step: this.state.step - 1
    });
  }

  isActive(step) {
    if(this.state.step === step) {
      return true;
    } else {
      return false;
    }
  }

  statusClass = (step) => {
    if(this.state.step === step) {
      return 'slide-active';
    } else if(this.state.step > step) {
      return 'slide-hidden-before';
    } else {
      return 'slide-hidden-after';
    }
  }

  setSlot = (appointmentStartDate, appointmentEndDate, proctorLocationSid, schedulingModule, calendarSid, fees = null) => {
    const { ScheduleStore } = this.props.store;

    if (fees) {
      this.setState({ fees });
    }

    this.setState({
      appointmentStartDate,
      appointmentEndDate,
      proctorLocationSid,
      calendarSid,
      schedulingModule
    }, ()=> {
      if(schedulingModule === 'register-blast') {
        // If this is a RegisterBlast location
        // get a RB scheduling token.
        ScheduleStore.getSchedulingToken(this.state.examSid, this.state.sessionSid, proctorLocationSid, appointmentStartDate);
      }
    });
  }

  confirmSlot = async e => {
    const { reschedule, store, proctorGroupSid } = this.props;
    const {
      appointmentStartDate,
      appointmentEndDate,
      calendarSid,
      examSid,
      proctorLocationSid,
      schedulingModule,
      sessionSid
    } = this.state;
    const { ExamStore, ScheduleStore, StudentStore } = store;
    const { duration } = ExamStore.examSession.examConfiguration;
    const { schedulingURL } = ScheduleStore;

    if (schedulingModule === 'register-blast') {
      try {
        const win = window.open(reschedule ? schedulingURL.replace('/schedule', '/reschedule') : schedulingURL);

        e.preventDefault();

        const int = setInterval(() => {
          try {
            if (win.closed) {
              clearInterval(int);
              closeDrawer(null, this.props.parent, '/', StudentStore.getStudentExams);
            }
          } catch (err) {}
        }, 1000);
      } catch (err) {
        console.warn('window.open didn’t work.')
      }
    } else {
      const payload = {
        appointmentStartDateTime: appointmentStartDate,
        appointmentEndDateTime: appointmentEndDate,
        type: schedulingModule,
        proctorLocationSid
      };

      if (!payload.appointmentEndDateTime) {
        payload.appointmentEndDateTime = moment(appointmentStartDate).add(duration, 'minutes');
      }

      if (calendarSid) {
        payload.calendarSid = calendarSid;
      }

      if (!reschedule) {
        // When scheduling a SmarterScheduling
        // session, the API expects an external
        // reservation ID, so we need to make one.
        payload.proctorGroupSid = proctorGroupSid;
        ScheduleStore.createReservation(
          payload,
          examSid,
          sessionSid,
          () => this.nextStep(null)
        );
      } else {
        ScheduleStore.rescheduleAppointment(
          examSid,
          sessionSid,
          payload,
          () => {
            this.setStep(null, 6)
          },
          () => {
            this.setStep(null, 7)
          }
        );
      }
    }
  }

  toggleSubmitButton = () => {
    this.setState(prevState => ({
      isSubmitDisabled: !prevState.isSubmitDisabled
    }))
  }

  renderFeeDescriptions = () => {
    const { translation } = this.props;
    const { fees } = this.state;
    const { PaymentStore } = this.props.store;

    if (PaymentStore.schedulingRuleInformation.length > 0) {
      return (
        <div>
          <div className="scheduling-rule--terms">
            <b>{translation.scheduling_fees.terms}</b>
          </div>
          <ul className="table-list" id="dash-bullet">
            {PaymentStore.schedulingRuleInformation.map((rule, i) => {
              if (rule.feeAmount > 0) {
                return (
                  <li
                    key={i}
                    className="scheduling-rule--list-item"
                  >
                    { rule.isRefundEligible ?
                      `${translation.scheduling_fees.refundable.replace('%feeName%', rule.name)}` :
                      `${translation.scheduling_fees.nonrefundable.replace('%feeName%', rule.name)}`
                    }
                  </li>
                )
              }
              return null;
            })}
            <li
              key='default'
              className="scheduling-rule--list-item"
            >
              {translation.scheduling_fees.default_terms}
            </li>
          </ul>
        </div>
      );
    } else if (fees && fees.userTotal > 0) {
      return (
        <div>
          <div className="scheduling-rule--terms">
            <b>{translation.scheduling_fees.terms}</b>
          </div>
          <ul className="table-list" id="dash-bullet">
            <li
              key='default'
              className="scheduling-rule--list-item"
            >
              {translation.scheduling_fees.default_terms}
            </li>
          </ul>
        </div>
      );
    }
    return null;
  }

  renderPricingButton = () => {
    const { translation } = this.props;
    const { fees } = this.state;
    const { PaymentStore } = this.props.store;

    if(fees) {
      if(fees.userTotal > 0) {
          return (
            <div>
              <div id="scheduling-fee-agreement--div">
                <span id="scheduling-fee-agreement--toggle">
                  <input
                    type="checkbox"
                    id="scheduling-fee-agreement"
                    className="switch-input"
                    defaultChecked={false}
                    onChange={this.toggleSubmitButton}
                    onKeyDown={handleSwitchInputKeys}
                  />

                  <label
                    className="switch-label"
                    htmlFor="scheduling-fee-agreement"
                  >
                    <span className="meta">
                      {translation.scheduling_fees.meta}
                    </span>
                  </label>
                </span>
                <label htmlFor="scheduling-fee-agreement">
                  {translation.scheduling_fees.confirmation}
                </label>
              </div>
              <button
                disabled={this.state.isSubmitDisabled}
                className="btn"
                onClick={(e) => {this.nextStep(e)}}
              >
                {translation.next}
              </button>
            </div>
          );
      }

      if(fees.userTotal === 0 && PaymentStore.schedulingRuleInformation.length > 0) {
        return (
          <div>
            <div id="scheduling-fee-agreement--div">
                <span id="scheduling-fee-agreement--toggle">
                  <input
                    type="checkbox"
                    id="scheduling-fee-agreement"
                    className="switch-input"
                    defaultChecked={false}
                    onChange={this.toggleSubmitButton}
                    onKeyDown={handleSwitchInputKeys}
                  />

                  <label
                    className="switch-label"
                    htmlFor="scheduling-fee-agreement"
                  >
                    <span className="meta">
                      {translation.scheduling_fees.meta}
                    </span>
                  </label>
                </span>
              <label htmlFor="scheduling-fee-agreement">
                {translation.scheduling_fees.confirmation}
              </label>
            </div>
          <button
            className="btn"
            onClick={this.submitSchedule}
            disabled={this.state.isSubmitDisabled}
          >
            {translation.schedule}
          </button>
          </div>
        );
      } else if (fees.userTotal === 0) {
        return (
          <button
            className="btn"
            onClick={this.submitSchedule}
          >
            {translation.schedule}
          </button>
          )
      }
    }
  }

  submitSchedule = () => {
    const {
      appointmentStartDate,
      examSid,
      fees,
      proctorLocationSid,
      schedulingModule,
      sessionSid
    } = this.state;
    const { store, proctorTypeSubCategorySid } = this.props;
    const { ScheduleStore } = store;

    const payload = {
      appointmentDateTime: appointmentStartDate,
      amount: fees.userTotal,
      currency: fees.currencyCode,
      proctorTypeSubCategorySid,
      proctorLocationSid,
      type: schedulingModule
    }

    ScheduleStore.createAppointment(
      examSid,
      sessionSid,
      payload,
      () => { this.setStep(null, 6) }
    );
  }

  startOver = () => {
    const { ScheduleStore } = this.props.store;

    ScheduleStore.checkOnlineReservation(
      this.state.examSid,
      this.state.sessionSid,
      () => {this.setStep(null, 1)},
      this
    );
  }

  render() {
    const { store, translation } = this.props;
    const { ScheduleStore, SessionStore, StudentStore, UserStore } = store;
    const { userTimezone } = this.props.store.SessionStore;

    if(!SessionStore.loading || ScheduleStore.onlineAvailability.length > 0) {
      if (UserStore.liveProctoringBlocked) {
        return (
          <div className="page page--error wrap">
            <div className="panel--brief">
              <i className="page--error__icon"><icons.iconLock /></i>
              <div>
                <h1 className='panel__title'>{translation.blocked.heading}</h1>
                <p>{translation.blocked.message}</p>
              </div>
            </div>
          </div>
        )
      } else if (!this.state.complete) {
        return(
          <div className="drawer__content">
            <header className="drawer__header">
              <div className="wrap">
                <h1 className="drawer__title">{translation.intro.heading}</h1>
              </div>
            </header>

            <div className="slide-wrap slide-wrap--sticky wrap">
              <div className={`panel panel--medium ${this.statusClass(1)}`}>
                <div className="text-block">
                  <h5><strong>{translation.heading}</strong></h5>
                  <ul>
                      {translation.requirements.map(
                          (requirement, i) => {
                            return(
                                <li key={i}>{requirement}</li>
                            )
                          }
                      )}
                  </ul>
                  <p>
                    <strong>
                      {translation.record_reminder}
                    </strong>
                  </p>
                </div>

                { /*
                  <div className="note">
                    <p>
                      <strong>{translation.cost_heading}</strong>
                    </p>
                    <p>{translation.cost_varies}</p>
                    <p>{translation.cost_info}</p>
                  </div>
                  */
                }

                <button className="btn" onClick={(e) => {this.nextStep(e)}}>
                  <icons.iconCalendar />
                  {translation.intro.button}
                </button>
              </div>

              <div className={`panel panel--large media--alt media--alt-top ${this.statusClass(2)}`}>
                {/* Date picker */}
                <ScheduleDate
                  {...this.props}
                  combined={true}
                  hybrid={true}
                  examSid={this.state.examSid}
                  sessionSid={this.state.sessionSid}
                  setStep={this.setStep}
                  step={this.state.step}
                />

                {/* Select date message */}
                {!ScheduleStore.onlineDate && ScheduleStore.onlineAvailability.length === 0 &&
                  <div className="media__copy">
                    <BlackoutList {...this.props} />

                    <span className="no-results">{translation.select_date}</span>
                  </div>
                }

                {/* Availability list */}
                {(ScheduleStore.onlineDate || ScheduleStore.onlineAvailability.length > 0) &&
                  <div className="media__copy">
                    <BlackoutList {...this.props} />

                    <ScheduleTable
                      step={this.state.step}
                      setStep={this.setStep}
                      getSid={this.getSid}
                      routing={this.props.routing}
                      setSlot={this.setSlot}
                      parent={this}
                      {...this.props}
                      sessionSid={this.state.sessionSid}
                    />
                  </div>
                }
              </div>

              <div className={`panel panel--brief ${this.statusClass(3)}`}>
                <h2 className="panel__title">{translation.confirm.heading}</h2>

                <p>{translation.confirm.body_pre}</p>

                <time className="text-code">
                  {moment(this.state.appointmentStartDate).tz(userTimezone).format('dddd, MMMM D [at] h:mma z')}
                </time>

                <p>{translation.confirm.body_post}</p>

                <button
                  className="btn"
                  onClick={e=> this.confirmSlot(e)}
                >
                  <icons.iconCalendarPlus />
                  {translation.confirm.button}
                </button>

                <span className="preposition--vertical">{translation.confirm.or}</span>

                <button
                  className="btn--link"
                  onClick={(e) => this.setStep(e, 2)}
                >
                  {translation.confirm.change_time}
                </button>
              </div>

              <div className={`panel panel--brief ${this.statusClass(4)}`}>
                <Pricing fees={this.state.fees} scheduler={this} isSubmitDisabled={this.state.isSubmitDisabled} {...this.props} />

                {this.renderFeeDescriptions()}

                {this.renderPricingButton()}

                <span className="preposition--vertical">{translation.confirm.or}</span>

                <button
                  className="btn--link"
                  onClick={(e) => this.setStep(e, 3)}
                >
                  {translation.go_back}
                </button>
              </div>

              <div className={`panel panel--brief ${this.statusClass(5)}`}>
                <h2 className="panel__title">{translation.payment.heading}</h2>

                <Payments submit={this.submitSchedule} {...this.props} />
              </div>

              <div className={`panel panel--brief ${this.statusClass(6)}`}>
                <h2 className="panel__title">{translation.confirmed.heading}!</h2>

                <p>{translation.confirmed.body}</p>

                <time className="text-code">
                  {moment(this.state.appointmentStartDate).tz(userTimezone).format('dddd, MMMM D [at] h:mma z')}
                </time>

                <a
                  className="btn btn--icn-right"
                  href="#app"
                  onClick={(e) => {closeDrawer(e, this.props.parent, '/', StudentStore.getStudentExams)}}
                >
                  {translation.confirmed.button}
                  <icons.iconCircleRight />
                </a>
              </div>

              <div className={`panel panel--brief ${this.statusClass(7)}`}>
                <h2 className="panel__title">{translation.refresh.heading}</h2>

                <p>{translation.refresh.body}</p>

                <a
                  className="btn btn--icn-right"
                  href="#app"
                  onClick={(e) => {closeDrawer(e, this.props.parent, '/', StudentStore.getStudentExams)}}
                >
                  {translation.confirmed.button}
                  <icons.iconCircleRight />
                </a>
              </div>
            </div>
          </div>
        )
      } else {
        return(
          <div className="drawer__content">
            <header className="drawer__header">
              <div className="wrap">
                <h1 className="drawer__title">{translation.heading}</h1>
              </div>
            </header>

            <div className="panel panel--brief">
              <img className="panel__img" src="./static/img/logo-registerblast.png" width="200" alt="RegisterBlast" />

              <h2 className="panel__title">{translation.confirmed.heading}!</h2>

              <p>{translation.confirmed.body}</p>

              <a
                className="btn btn--icn-right"
                href="#app"
                onClick={(e) => {closeDrawer(e, this.props.parent, '/', StudentStore.getStudentExams)}}
              >
                {translation.confirmed.button}
                <icons.iconCircleRight />
              </a>
            </div>
          </div>
        )
      }
    }

    return null;
  }
})

export default translate('ScheduleHybrid')(ScheduleHybrid);



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/ScheduleHybrid.js